import { FunctionComponent } from 'react'

import { SwitchButton, SwitchInput, SwitchLabel, SwitchTitle } from './styles'
import { ISwitchProps } from './SwitchComponent.types'

const Switch: FunctionComponent<ISwitchProps> = ({
  id,
  checked,
  onChange,
  large,
}) => {
  return (
    <>
      <SwitchInput
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange}
      />
      <SwitchLabel
        className="switch-label"
        htmlFor={id}
        checked={checked}
        large={large}
      >
        <SwitchTitle checked={checked}>
          {!large
            ? checked
              ? 'Ativo'
              : 'Inativo'
            : checked
            ? 'Veiculo ativo'
            : 'Veiculo inativo'}
        </SwitchTitle>
        <SwitchButton className="switch-button" />
      </SwitchLabel>
    </>
  )
}

export default Switch
